import React, { createContext, useState, useContext, useCallback, useEffect } from "react";

//context que armazena dados da linha selecionada de uma tabela
const ListManagerContext = createContext({
	lineSelected: null,
	isCard: false,
	handleLineClick: () => { },
	handleClickCard: () => { },
	closeForm: () => { },
});

export const ListManagerProvider = ({ children }) => {
	const [lineSelected, setLineSelected] = useState(null);
	const [isCard, setIsCard] = useState(null);
	const [selectedIdx, setSelectedIdx] = useState(null);

	const handleLineClick = useCallback((data, idx, isCard) => {
		setLineSelected(data);
		setSelectedIdx(idx);
		setIsCard(isCard);
	}, []);

	const closeForm = () => {
		setLineSelected(null);
	};

	useEffect(() => {
		const bodyEl = document.querySelector('body');
		bodyEl.style.setProperty('--consultaWidth', lineSelected ? '400px' : '0px');
	}, [lineSelected]);

	return (
		<ListManagerContext.Provider
			value={{ lineSelected, isCard, setIsCard, setLineSelected, handleLineClick, closeForm, selectedIdx, setSelectedIdx }}
		>
			{children}
		</ListManagerContext.Provider>
	);
};

export function useListManager() {
	const context = useContext(ListManagerContext);

	return context;
}
